import posthog from 'posthog-js'

import { env } from '@/env'

import type { PostHog } from 'posthog-js';

let ph: PostHog | null = null
let initialized = false

export function initPH(): PostHog | null {
  if (typeof window === 'undefined' || initialized) return ph
  const apiKey = env.NEXT_PUBLIC_EVNTTZ_POSTHOG_KEY
  if (!apiKey) return null

  posthog.init(apiKey, {
    defaults: '2025-05-24',
    api_host: 'https://app.posthog.com',
    autocapture: false,
    persistence: 'localStorage+cookie'
  })

  ph = posthog
  initialized = true
  return ph
}

export const getPH = () => ph
